export const GET_DASHBOARD_CONTENT_SUCCESS = "GET_DASHBOARD_CONTENT_SUCCESS";
export const GET_DASHBOARD_CONTENT_FAILURE = "GET_DASHBOARD_CONTENT_FAILURE";
export const GET_SIMON_DATA_SUCCESS = "GET_SIMON_DATA_SUCCESS";
export const GET_SIMON_DATA_FAILURE = "GET_SIMON_DATA_FAILURE";
export const GET_OFFER_DETAILS_SUCCESS= 'GET_OFFER_DETAILS_SUCCESS';
export const GET_OFFER_DETAILS_FAILURE = 'GET_OFFER_DETAILS_FAILURE';
export const AEM_TRIP_LEADS_REGION_NAMES = 'AEM_TRIP_LEADS_REGION_NAMES';
export const PLAN_TRIPS_DATA_SUCCESS = 'PLAN_TRIPS_DATA_SUCCESS';
export const PLAN_TRIPS_DATA_FAILURE = 'PLAN_TRIPS_DATA_FAILURE';
export const GET_DREAM_COMPONENT_CONTENT = 'GET_DREAM_COMPONENT_CONTENT';
export const UPCOMING_TRIPS_SUCCESS = 'UPCOMING_TRIPS_SUCCESS';
export const UPCOMING_TRIPS_FAILURE = 'UPCOMING_TRIPS_FAILURE';
export const ARN_CITY_DATA_SUCCESS = 'ARN_CITY_DATA_SUCCESS';
export const ARN_CITY_DATA_FAILURE = 'ARN_CITY_DATA_FAILURE';
export const ASPOTCONFIG = 'ASPOTCONFIG';

